import { FormControlLabel, FormControlLabelProps, styled } from '@mui/material';
import { secondary } from 'assets/colors/colors';

export const StyledFormControlLabel = styled((props: FormControlLabelProps) => (
  <FormControlLabel {...props} />
))(({ theme }) => ({
  background: theme.palette.primary.contrastText,
  '& .MuiFormControlLabel-label': {
    fontSize: '14px',
    fontWeight: 400,
    color: theme.palette.primary.main,
  },
  '&.Mui-checked': {
    color: secondary.main,
  },
}));
